import { boolean, mixed, object, string } from "yup";
import { StatusEnum } from "../../shared";

export const DEFAULT_VALUES = {
  name: "",
  hasParent: false,
  type: "",
  status: StatusEnum.ACTIVE,
  accountingActionChartOfAccounts: {},
};

export const VALIDATION_SCHEMA = object().shape({
  name: string().required("Harus diisi"),
  hasParent: boolean().required(),
  parentProductCategory: mixed().when("hasParent", {
    is: true,
    then: (schema) => schema.required("Harus diisi"),
    otherwise: (schema) => schema.nullable(),
  }),
  type: string().required("Harus diisi"),
  status: boolean().required("Harus diisi"),
});
